export default __webpack_public_path__ + "static/media/Date To.b227d010.svg";